import React, { useState, useRef, useEffect } from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import notesIcon from "assets/img/icons/Add notes-01.svg";
import share from "assets/img/icons/Share-01.svg";
import AddNote from "./Modals/Add Note/AddNote";
import SharePopup from "./Modals/Share/Share";
import { useSelector, useDispatch } from "react-redux";
import {
  MessageDetailsAction,
  ResetDataAction,
} from "../../Redux/Inbound/actions";
import moment from "moment";
import ReactAudioPlayer from "react-audio-player";
import "../../assets/css/Loaders/Inboundmessagedetails.css";
import {useNavigate} from "react-router-dom";

export default function MessagesDetails({ id }) {
  const dispatch = useDispatch();
  let data = useSelector((state) => state.inboundReducer.MessageDetails);
  const [showAddNotePopup, setShowAddNotePopup] = useState(false);
  const [showSendEmailPopup, setShowEmailPopup] = useState(false);
  const [loader, setLoader] = useState(false);
  const user = useSelector((state) => state.authReducer?.data);
  const navigate = useNavigate()
  // const role = localStorage.getItem("role");
  // const userRole = role
  //     ? new TextDecoder().decode(
  //         new Uint8Array(role.split(",").map(Number)).buffer
  //     )
  //     : null;
  const userRole = useSelector((state) => state.authReducer?.data?.role);





  useEffect(() => {
    async function fetchData() {
      if (id) {
        setLoader(true);
        let messageDetails = await MessageDetailsAction(dispatch, id, user?.accountID);
        if (messageDetails.success === false){
          navigate(`/${userRole}/message/notfound`);
        }
        setLoader(null);
      }
    }
    fetchData();
    return async () => {
      await ResetDataAction(dispatch);
    };
  }, [id]);
  const handleShowAddNotePopup = () => {
    setShowAddNotePopup(true);
  };

  const handleCloseAddNotePopup = () => {
    setShowAddNotePopup(false);
  };

  const handleShowEmailPopup = () => {
    setShowEmailPopup(true);
  };

  const handleCloseSendEmailPopup = () => {
    setShowEmailPopup(false);
  };

  // const handleDownload = () => {
  //     if (audioRef.current) {
  //         const audioElement = audioRef.current.audio.current;
  //         const audioSrc = audioElement.src;
  //         window.open(audioSrc, '_blank');
  //     }
  // };

  let initials;
  let formattedDateTime;
  if (data && Object.keys(data).length !== 0) {
    const getInitials = (fullName, firstName, lastName) => {
      if (fullName) {
        return fullName
          .split(" ")
          .map((name) => name.charAt(0))
          .join("")
          .toUpperCase();
      } else if (firstName && lastName) {
        return `${firstName[0]}${lastName[0]}`.toUpperCase();
      } else {
        return "NA";
      }
    };

    initials = getInitials(
      data?.messageData?.name,
      data?.messageData?.firstName,
      data?.messageData?.lastName,
    ).slice(0, 2);
    formattedDateTime = moment(data?.createdAt).format("YYYY-MM-DD HH:mm:ss A");
  }

  return (
    <>
      {loader ? (
        <>
          <div className="loader-messageDetails">
            <div className="wrapper">
              <div className="circle"></div>
              <div className="line-1"></div>
              <div className="line-2"></div>
              <div className="line-3"></div>
              <div className="line-4"></div>
              <div className="line-5"></div>
              <div className="line-6"></div>
              <div className="line-7"></div>
              <div className="line-8"></div>
              <div className="line-9"></div>
              <div className="line-10"></div>
              <div className="line-11 "></div>
              <div className="line-12 "></div>
            </div>
          </div>
        </>
      ) : data && Object.keys(data).length !== 0 ? (
        <>
          <Container
            style={{ overflowY: "auto", height: "60%" }}
            className="pl-0 mb-2 "
          >
            {/* {messageData?.map((data, index) =>
                (
                    < > */}
            <Row className=" d-flex align-items-center mt-3 w-100 ml-0">
              <Col md={2}>
                {/* <small className='custom-bg-messageSection-top ml-4'>{initials}</small> */}
                <Image
                  src={`https://ui-avatars.com/api/?name=${initials}&background=172e57&color=fff&size=40`}
                  roundedCircle
                  className="custom-avatar"
                />
              </Col>
              <Col className="d-flex flex-column p-0">
                <p className="message-ptag">
                  {data?.messageData?.name
                    ? data.messageData?.name
                    : data?.messageData?.firstName &&
                        data?.messageData?.lastName
                      ? `${data.messageData?.firstName} ${data?.messageData?.lastName}`
                      : "Not Available"}
                </p>
                {/* <p >Dacula, Geogia</p> */}
              </Col>
            </Row>
            <Row className="mt-5 d-flex">
              <Col md={5} className="p-0 text-center">
                <p className="date-small">From +{data?.callerNumber}</p>
              </Col>
              <Col md={1} className="p-0 text-center">
                -
              </Col>
              <Col md={6} className="p-0 text-center">
                <p className="date-small">To +{data?.callTo}</p>
              </Col>
            </Row>
            <Row className="d-flex ml-0">
              <Col md={5} className="p-0 text-center">
                <p className="date-small">Answered by {data?.answeredBy}</p>
              </Col>
              <Col md={1} className="p-0 text-center">
                -
              </Col>
              <Col md={6} className="p-0 text-center">
                <p className="date-small">{formattedDateTime}</p>
              </Col>
            </Row>
            <Row className="mt-4 ml-4">
              <Col className="d-flex justify-content-bwteen p-0">
                <p className="message-p-tag m-0">Call recording</p>
              </Col>
              {/* <Col><p className='message-p-tag m-0'>Available for 89 days</p></Col> */}
            </Row>
            <Row className="mt-4 d-flex align-items-center justify-content-center ml-2">
              <Col>
                <ReactAudioPlayer
                  src={data?.recordingLink}
                  // autoPlay
                  controls
                  className="w-100"
                />
              </Col>
              {/* <Col className='p-1 ' md={2}><img src={Download} width={20} alt='download' className='mr-1' onClick={handleDownload} /></Col> */}
            </Row>
            {data.messageData ? (
              <Row className="mt-4 d-flex flex-column ml-2">
                {Object.entries(data?.messageData).map(
                  ([key, value]) =>
                    key !== "id" && (
                      <Container key={key} className="mt-2 mb-1">
                        <div className="mb-1">
                          <strong className="message-p-tag">
                            {key.charAt(0).toUpperCase() + key.slice(1)}:
                          </strong>
                        </div>
                        <div>{value}</div>
                      </Container>
                    ),
                )}
              </Row>
            ) : (
              ""
            )}
          </Container>
          <hr></hr>
          {data?.notes?.length ? (
            <>
              <Container style={{ overflowY: "auto", height: "22%" }}>
                <p className="custom-p-tag ml-2">Notes</p>
                <Row className="ml-1">
                  <Col>
                    {data?.notes?.map((obj, index) => (
                      <div key={index}>
                        {Object.entries(obj).map(
                          ([key, value]) =>
                            key !== "id" && <li key={key}>{value}</li>,
                        )}
                      </div>
                    ))}
                  </Col>
                </Row>
              </Container>
              {/* <hr></hr> */}
            </>
          ) : (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ height: "22%" }}
            >
              <p>No Note Added yet</p>
            </div>
          )}

          <Row className="d-flex justify-content-center align-items-end">
            <Col md={4}>
              <p
                className="custom-style-addShare p-1 "
                onClick={handleShowAddNotePopup}
              >
                <img src={notesIcon} alt="notes" width={20} className="mr-1" />
                Add Note
              </p>
            </Col>
            <Col md={4}>
              <p
                className="custom-style-addShare p-1"
                onClick={handleShowEmailPopup}
              >
                <img src={share} alt="share" width={20} className="mr-1" />{" "}
                Share
              </p>
            </Col>
          </Row>
          <AddNote
            show={showAddNotePopup}
            handleClose={handleCloseAddNotePopup}
            data={data}
          />
          <SharePopup
            show={showSendEmailPopup}
            handleClose={handleCloseSendEmailPopup}
          />
        </>
      ) : (
        <div className="d-flex h-75 justify-content-center align-items-center">
          <h5 className="custom-color-grey">Nothing to show</h5>
        </div>
      )}
    </>
  );
}
